export default __webpack_public_path__ + "static/2b)giggle-e8a84a5235318947334572fccab14e62.mp3";